import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const avatar = css`
  background-color: ${colors.custom.accessory};
  color: ${colors.primary.default};
`;
